import Service from "../service";
class AdsService extends Service {
    constructor(name, config, stack) {
        super(name, stack);
        this.config = config;
    }
}
export { AdsService };
//# sourceMappingURL=adsservice.js.map